<div fxLayout="column"  fxLayoutGap="15px">
    <!-- <div style=" display: flex;justify-content: center;">
        <label class="label-header">Schedule Result Declaration </label>
    </div> -->
    <div style="width: 100%; text-align: center; color: #999999; font-size: 16px; font-family: Montserrat; font-weight: 400; line-height: 20.80px; letter-spacing: 0.03px; word-wrap: break-word">Choose a date and time for users to view results in the competition zone</div>
    <div fxLayout="column">
        <div fxLayout="column" fxLayoutGap="20px" >
            <div  style="display: flex; align-items: center; justify-content: space-between;">
                <button class="mx-1 col-md-3" style="display:inline-flex;justify-content: center;width: 46%;align-items: center; border: 1px solid #ECECEC;border-radius: 8px;
                        background: white; height: 56px;" id="reportrange" type="button">
                    <span>
                        <img src="assets/calender.svg" >
                    </span>
                        <input matInput [min]="minDate"  [matDatepicker]="picker" [formControl]="date">
                        <mat-datepicker-toggle matSuffix [for]="picker">
                            <mat-icon matDatepickerToggleIcon style="color: #386AF6">arrow_drop_down</mat-icon>
                          </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </button>
                <button style="display: flex; width: 53%; position: relative;; border: 1px solid #ECECEC;border-radius: 8px;height: 56px;background: white; justify-content: space-around; align-items: center;">
                    <span>
                        <img src="assets/clock.svg" style="margin-right: 20px;">
                    </span>
                <mat-form-field [floatLabel]="'never'">
                    <mat-label style="color: #0E0E0E;">Select Time</mat-label>
                    <mat-select [(value)]="selected">
                        <mat-option *ngFor="let time of times" [value]="time">
                            {{time}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                </button>
            </div>
        </div>
    </div>
    <div fxLayout="column">
        <div fxLayout="column" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutAlign="center center">
                <button type="button" (click)="closePopup()" class="verify-btn" fxFlex="40" fxLayoutAlign="center center"
                    style="padding:10px 0;">Cancel
                </button>
                <button *ngIf="selected!=''" type="button" (click)="declareResult()" class="verify-btn" fxFlex="40" fxLayoutAlign="center center"
                    style="padding:10px 0;background: #386AF6; color:#fff">Schedule</button>
                <button *ngIf="selected==''" type="button"  class="verify-btn" fxFlex="40" fxLayoutAlign="center center"
                    style="padding:10px 0;background: #869ddd; color:#fff">Schedule</button>
            </div>
        </div>
    </div>
</div>
